import React from 'react'

import { CHECK_FILLED } from '../../../assets/images'
import { ReactListProps } from '../types'
import './ReactDifferentIconList.scss'

const ReactDifferentIconList = (props: ReactListProps): JSX.Element => {
  const { id, differentIconsList = [] } = props

  return (
    <div data-testid={`react-different-icon-list-container`} className={`react-different-icon-list-container`}>
      {differentIconsList?.length > 0 && (
        <div className='different-icon-list-details'>
          {differentIconsList?.map((listItem, index) => {
            const { title = '', link = '', openinnewtab, anchor, icon = CHECK_FILLED, iconAlt } = listItem
            const newUrl = anchor ? link + `#${anchor}` : link

            return (
              <div className='different-icon-list-item' key={`different-icon-list-item-${index}}`} id={id}>
                {icon && (
                  <div data-testid='list-icon-wrapper' className='different-icon-list-icon'>
                    <img src={icon} alt={iconAlt} />
                  </div>
                )}

                <div className='different-icon-list-point' data-testid={`react-list-item-desc`}>
                  {link ? (
                    <a onClick={() => window.open(newUrl, openinnewtab)}>
                      <span>{title}</span>
                    </a>
                  ) : (
                    <span>{title}</span>
                  )}
                </div>
              </div>
            )
          })}
        </div>
      )}
    </div>
  )
}

export default ReactDifferentIconList
